export const setToken = (token) => {
  localStorage.setItem("access_token", JSON.stringify(token));
};

export const getToken = () => {
  const tokenString = localStorage.getItem("access_token");
  const userToken = JSON.parse(tokenString);
  return userToken;
};
